import { render, staticRenderFns } from "./CsSettings.vue?vue&type=template&id=706745b8&scoped=true&"
import script from "./CsSettings.vue?vue&type=script&lang=js&"
export * from "./CsSettings.vue?vue&type=script&lang=js&"
import style0 from "./CsSettings.vue?vue&type=style&index=0&id=706745b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706745b8",
  null
  
)

export default component.exports